<template>
    <transition name="fade" mode="out-in">
        <component :is="currentComponent" :selection="selection" :items="items" @toIndex="goToIndex" @toCreate="goToCreate" @updateItems="updateItems"></component>
    </transition>
</template>

<script>
import index from './index';
import create from './create';

export default {
    name: "packaging-container",
    components:{
        index,
        create
    },
    data(){
        return {
            currentComponent: 'index',
        };
    },
    props:['selection', 'items'],
    methods:{
        goToIndex(){
            this.currentComponent = 'index';
        },
        goToCreate(){
            this.currentComponent = 'create';
        },
        updateItems(items){
            this.$emit('updateItems', items);
        }
    },
}
</script>

<style scoped>

</style>
